import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import LastVersion from "../../components/LastVersion";
import Table from "../../components/OlderVersions/Table";
import { IVersionsResponse } from "../../utils/fetchers/types";
import {
  getVersions,
  homePageParams
} from "../../utils/fetchers/version";
import logo from '../../assets/icons/logo.svg'

import styles from './Home.module.css'

const Home: React.FC = () => {
  const [versionsData, setVersionsData] = useState<IVersionsResponse>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const params: homePageParams = {
      client: searchParams.get("client"),
      version: searchParams.get("version"),
    }
    getVersions(params)
      .then(data => {
        const isVersionValid = !!(data.versions.filter((item) => item.version === data.currentVersion).length);
        if (!isVersionValid) data.currentVersion = '';

        data.versions = data.versions.filter((item) => item.client === data.client);
        setVersionsData(data);
      })
  }, [])

  return (
    <>
      {
        (versionsData && versionsData.versions.length)
          ?
          <div className={styles.wrapper}>
            <div className={styles.logo}>
              <img src={logo} alt="logo" />
            </div>
            <LastVersion
              client={versionsData.client}
              data={versionsData.versions[0]}
            />
            {
              versionsData.versions.length > 1
              &&
              <Table
                client={versionsData.client}
                versions={versionsData.versions.slice(1)}
                currentVersion={versionsData.currentVersion}
              />
            }
          </div>
          :
          <></>
      }
    </>
  );
};

export default Home;
